import React, { useEffect } from 'react';
import StatusEnum from 'axios/enum';
import { MethodEnum } from 'axios/type';
import useAxios from 'axios/useAxios';
import { localStorageRetaierIdName, showResponseSnackBar } from 'consts';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { loginAction } from 'reducer/common/login';
import logoSm from 'theme/assets/images/logo-sm.png';
import logo from 'theme/assets/images/logo.png';
import {
  getMenuIsOpenReducer,
  menuIsOpenAction,
} from 'reducer/common/menuDropback';
import { EnumAppRouter } from 'router/enum';
import { getUserInfoReducer } from 'reducer/common/userInfo';

const Header = () => {
  const { setLoginRedux } = loginAction;
  const { setMenuIsOpen } = menuIsOpenAction;
  const menuIsOpenVal = useSelector(getMenuIsOpenReducer);
  const { userId } = useSelector(getUserInfoReducer);

  const axios = useAxios();
  const dispatch = useDispatch();

  const handleOpenMenu = () => {
    dispatch(setMenuIsOpen(!menuIsOpenVal));
  };

  /** 登出 */
  const handleLogout = async () => {
    const response = await axios.doAxios(MethodEnum.post, 'token/logout');
    if (response) {
      const { status } = response.data;
      showResponseSnackBar(response.data);
      localStorage.removeItem(localStorageRetaierIdName);
      if (status === StatusEnum.完成) {
        dispatch(setLoginRedux(false));
      }
    }
    window.close();
  };

  useEffect(() => {
    if (menuIsOpenVal) {
      document.body.classList.add('sidebar-enable');
    } else {
      document.body.classList.remove('sidebar-enable');
    }
    dispatch(setMenuIsOpen(menuIsOpenVal));
  }, [menuIsOpenVal]);

  return (
    <div className="navbar-custom">
      <div className="container-fluid">
        <ul className="list-unstyled topnav-menu float-right mb-0">
          {/* <li className="dropdown notification-list">
            <Link
              className="nav-link waves-effect waves-light"
              to={EnumAppRouter.登入}
            >
              <i className="icon-menu_home" />
              <span className="pro-user-name"> 回首頁 </span>
            </Link>
          </li> */}

          <li className="dropdown notification-list">
            <span className="nav-link waves-effect waves-light">
              <i className="icon-circle-user1 mr-1 gray" />
              <span className="pro-user-name">{userId}</span>
            </span>
          </li>
          <li className="dropdown notification-list">
            <Link
              className="nav-link waves-effect waves-light"
              to={EnumAppRouter.登出頁}
              onClick={() => handleLogout()}
            >
              <i className="icon-right-from-bracket gray" />
              <span className="pro-user-name"> 登出 </span>
            </Link>
          </li>
        </ul>

        <ul className="list-unstyled topnav-menu topnav-menu-left m-0">
          <li className="d-block d-lg-none">
            <button
              type="button"
              className="button-menu-mobile waves-effect waves-light"
              onClick={() => {
                handleOpenMenu();
              }}
            >
              <i className="icon-menu" />
            </button>
          </li>
        </ul>

        <div className="logo-box">
          <div
            className="logo text-center"
            // to={getLayoutLinkString(EnumLayoutRouter.訂單下載)}
          >
            <span className="d-block d-lg-none">
              <img src={logoSm} alt="" height="46" />
            </span>
            <span className="logo-lg">
              <img src={logo} alt="" height="40" />
            </span>
          </div>
        </div>

        <div className="clearfix" />
      </div>
    </div>
  );
};
export default Header;
